import {
  Component,
  ViewContainerRef,
  ViewChild,
  OnDestroy,
  Type,
  inject,
  AfterViewInit,
  TemplateRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SvgIconsComponent } from '../../components/svg-icons/svg-icons.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicRouteHandlingService } from '../../services/dynamic-route-handling.service';
import { NgbModalService } from '../../services/ngb-modal.service';
import { NgClass } from '@angular/common';

/**
 * Interface for the route data used by DynamicRouteHandlerComponent
 */
export interface DynamicRouteData {
  component: Type<any>;
  modalTitle: string;
  modalFooterButtonText: string;
  modalType: string;
  modalSize?: string; // Optional size parameter ('sm', 'lg', 'xl', 'xxl', etc.)
  returnRoute: string;
  modalBodyClass?: string;
}

@Component({
  selector: 'lib-dynamic-route-handler',
  imports: [SvgIconsComponent, NgClass],
  templateUrl: './dynamic-route-handler.component.html',
  styles: ``
})
export class DynamicRouteHandlerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('modal', { static: true }) modalTemplate!: TemplateRef<any>;
  @ViewChild('dynamicComponentRef', { read: ViewContainerRef, static: false }) dynamicComponentRef!: ViewContainerRef;

  #route = inject(ActivatedRoute);
  #modalService = inject(NgbModal);
  #router = inject(Router);
  // #cdr = inject(ChangeDetectorRef);
  #dynamicRouteHandlingService = inject(DynamicRouteHandlingService);
  #ngbModelService = inject(NgbModalService);

  // private componentRef: ComponentRef<any> | null = null;
  private modalRef: any = null;
  modalTitle = this.#route.snapshot.data['modalTitle'];
  modalFooterButtonText = this.#route.snapshot.data['modalFooterButtonText'];
  modalType = this.#route.snapshot.data['modalType'];
  modalSize = this.#route.snapshot.data['modalSize'];
  modalBodyClass = this.#route.snapshot.data['modalBodyClass'];

  ngAfterViewInit(): void {
    const component = this.#route.snapshot.data['component'];
    if (component) {
      this.openModal(component);
    }
  }

  openModal(component: Type<any>): void {
    const modalOptions = this.#ngbModelService[(this.modalType as keyof NgbModalService) ?? 'rightModal'];

    // If modalSize is provided in the route data, add it to the modal options
    this.modalRef = this.#modalService.open(
      this.modalTemplate,
      this.modalSize ? { ...modalOptions, size: this.modalSize } : modalOptions
    );

    setTimeout(() => {
      this.createComponent(component);
    }, 0);
  }

  private createComponent(component: Type<any>): void {
    if (this.dynamicComponentRef) {
      this.#dynamicRouteHandlingService.componentRef.next(this.dynamicComponentRef.createComponent(component));
      // this.#cdr.detectChanges();
    }
  }

  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
    setTimeout(() => {
      this.destroyComponent();
    }, 0);
    this.#router.navigate([this.#route.snapshot.data['returnRoute']], { queryParamsHandling: 'preserve' });
  }

  private destroyComponent(): void {
    if (this.#dynamicRouteHandlingService.componentRef.value) {
      this.#dynamicRouteHandlingService.componentRef.value.destroy();
      this.#dynamicRouteHandlingService.componentRef.next(null);
    }
    if (this.dynamicComponentRef) {
      this.dynamicComponentRef.clear();
    }
  }

  saveFunction(): void {
    this.#dynamicRouteHandlingService.submitButton.next();
  }

  ngOnDestroy(): void {
    this.closeModal();
  }
}
